(ns ductile.ui.view-stack
  (:require [ductile.ui.components :as ui]
            [ductile.ui.deframe :as deframe]))

(defn push-view!
  "Push a view entry onto the unified view stack."
  [entry]
  (deframe/route-update! ::view-stack (fnil conj []) entry))

(defn pop-view!
  "Pop the top view from the unified view stack, restoring focus/scroll for fields views.
   When popping back to a :fields view, also pops it and refetches the route so
   server-provided options (e.g. carriers) are fresh. Wizard field values live in
   ::recorded-attrs, not the :fields entry, so no user data is lost.
   Accepts an optional context map {:result ... :params ...} passed to :view/on-pop."
  ([] (pop-view! nil))
  ([context]
   (let [stack (or @(deframe/!route-get ::view-stack) [])
         {:keys [focus-return-attr scroll-y] :view/keys [id]} (peek stack)
         new-stack (pop stack)
         ;; When landing on a :fields view, pop it too — its captured :ui/options
         ;; are stale. The route refetch below will provide fresh options.
         [new-stack popped-fields?]
         (if (= :fields (:view/type (peek new-stack)))
           [(pop new-stack) true]
           [new-stack false])]
     (deframe/tx!
      (cond-> (if (seq new-stack)
                [[:op/assoc-in [:current-route/transient ::view-stack] new-stack]]
                [[:op/dissoc-in [:current-route/transient ::view-stack]]])
        id (conj [:op/dissoc-in [:current-route/transient ::view-stack-results id]]
                 [:op/dissoc-in [:current-route/transient ::view-stack-data id]])))
     (when popped-fields?
       (deframe/route-refetch!))
     (when-let [on-pop (:view/on-pop (peek stack))]
       (on-pop context))
     (when (and (not popped-fields?) focus-return-attr)
       (when scroll-y
         (js/window.scrollTo 0 scroll-y))
       (ui/focus! (str "[data-testid=\"" focus-return-attr "\"]") {:find-focusable-parent? true})
       (js/requestAnimationFrame
        #(ui/scroll-into-view-with-margin! js/document.activeElement))))))
